import Swal from "sweetalert2";

export const showWarningAlert = (message) => {
  return Swal.fire({
    icon: "warning",
    title: "Datos incompletos",
    text: message,
    confirmButtonColor: "#009ee3",
    confirmButtonText: "Entendido",
  });
};

export const showErrorAlert = (title, message) => {
  return Swal.fire({
    icon: "error",
    title: title,
    text: message,
    confirmButtonColor: "#009ee3",
    confirmButtonText: "Entendido",
  });
};

export const showConfirmationAlert = (leaderData, amount, formatCurrency) => {
  return Swal.fire({
    icon: "question",
    title: "¿Confirmar retiro?",
    html: `
      <div style="
        background: rgba(0, 158, 227, 0.05);
        border: 1px solid rgba(0, 158, 227, 0.2);
        border-radius: 8px;
        padding: 20px;
        margin-top: 20px;
      ">
        <div style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 8px 0;
          border-bottom: 1px solid rgba(0, 158, 227, 0.1);
          margin-bottom: 8px;
        ">
          <span style="
            font-weight: 600;
            color: #009ee3;
            font-size: 14px;
          ">Propietario:</span>
          <span style="
            color: #212529ab;
            font-size: 14px;
            font-weight: 500;
            text-align: right;
          ">${leaderData.first_name} ${leaderData.last_name}</span>
        </div>
        <div style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 8px 0;
          border-bottom: 1px solid rgba(0, 158, 227, 0.1);
          margin-bottom: 8px;
        ">
          <span style="
            font-weight: 600;
            color: #009ee3;
            font-size: 14px;
          ">Email:</span>
          <span style="
            color: #212529ab;
            font-size: 14px;
            font-weight: 500;
            text-align: right;
          ">${leaderData.email}</span>
        </div>
        <div style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 8px 0;
          border-bottom: 1px solid rgba(0, 158, 227, 0.1);
          margin-bottom: 8px;
        ">
          <span style="
            font-weight: 600;
            color: #009ee3;
            font-size: 14px;
          ">Monto a retirar:</span>
          <span style="
            color: #212529ab;
            font-size: 14px;
            font-weight: 500;
            text-align: right;
          ">${formatCurrency(amount)}</span>
        </div>
        <div style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 8px 0;
          border-bottom: 1px solid rgba(0, 158, 227, 0.1);
          margin-bottom: 8px;
        ">
          <span style="
            font-weight: 600;
            color: #009ee3;
            font-size: 14px;
          ">Balance actual:</span>
          <span style="
            color: #212529ab;
            font-size: 14px;
            font-weight: 500;
            text-align: right;
          ">${formatCurrency(leaderData.earnings)}</span>
        </div>
        <div style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 8px 0;
        ">
          <span style="
            font-weight: 600;
            color: #009ee3;
            font-size: 14px;
          ">Balance después del retiro:</span>
          <span style="
            color: #009ee3;
            font-weight: 700;
            font-size: 16px;
            text-align: right;
          ">${formatCurrency(leaderData.earnings - amount)}</span>
        </div>
      </div>
    `,
    showCancelButton: true,
    confirmButtonColor: "#009ee3",
    cancelButtonColor: "#6c757d",
    confirmButtonText: "Sí, procesar retiro",
    cancelButtonText: "Cancelar",
  });
};

export const showSuccessAlert = (
  withdrawalAmount,
  newBalance,
  formatCurrency
) => {
  return Swal.fire({
    icon: "success",
    title: "¡Retiro exitoso!",
    html: `
      <div style="
        background: rgba(0, 158, 227, 0.05);
        border: 1px solid rgba(0, 158, 227, 0.2);
        border-radius: 8px;
        padding: 20px;
        margin-top: 20px;
      ">
        <div style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 8px 0;
          border-bottom: 1px solid rgba(0, 158, 227, 0.1);
          margin-bottom: 8px;
          padding-bottom: 12px;
        ">
          <span style="
            font-weight: 600;
            color: #009ee3;
            font-size: 14px;
          ">Monto retirado:</span>
          <span style="
            color: #212529ab;
            font-size: 14px;
            font-weight: 500;
            text-align: right;
          ">${formatCurrency(withdrawalAmount)}</span>
        </div>
        <div style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 8px 0;
        ">
          <span style="
            font-weight: 600;
            color: #009ee3;
            font-size: 14px;
          ">Balance restante:</span>
          <span style="
            color: #009ee3;
            font-weight: 700;
            font-size: 16px;
            text-align: right;
          ">${formatCurrency(newBalance)}</span>
        </div>
      </div>
    `,
    confirmButtonColor: "#009ee3",
    confirmButtonText: "Aceptar",
  });
};

export const showDownloadSuccessAlert = () => {
  return Swal.fire({
    icon: "success",
    title: "¡Descarga exitosa!",
    text: "El archivo de pagos se ha descargado correctamente",
    confirmButtonColor: "#009ee3",
    confirmButtonText: "Aceptar",
  });
};

export const showDownloadErrorAlert = () => {
  return Swal.fire({
    icon: "error",
    title: "Error",
    text: "No se pudo generar el archivo de pagos. Inténtelo de nuevo más tarde.",
    confirmButtonColor: "#009ee3",
    confirmButtonText: "Aceptar",
  });
};

export const showLoadingAlert = (title, message) => {
  return Swal.fire({
    title: title,
    html: message,
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });
};
